// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartDefaultFunction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import constants from 'logic/data/Izenda.ReportPartFieldConstants';
import { CHART_TYPE } from 'logic/data/Izenda.ChartDefaultConfig';

const FUNCTION = constants.FUNCTION;
const FORMAT_KEY = constants.FORMAT_KEY;
const DefaultFunction = {};
const ERROR_TYPE = constants.ERROR_TYPE;

/* LINE CHART */
DefaultFunction[CHART_TYPE.Line] = {};
// line chart - labels & separators
DefaultFunction[CHART_TYPE.Line]['labels'] = DefaultFunction[CHART_TYPE.Line]['separators'] = {
  Datetime: {
    FUNCTION: FUNCTION.GROUP,
    FORMAT: FORMAT_KEY.YEAR,
    ON_NULL_FUNCTION: ERROR_TYPE.ERROR_MESSAGE
  },
  Time: {
    FUNCTION: FUNCTION.GROUP,
    FORMAT: FORMAT_KEY.DEFAULT_TIME,
    ON_NULL_FUNCTION: ERROR_TYPE.ERROR_MESSAGE
  },
  Others: {
    FUNCTION: FUNCTION.GROUP,
    FORMAT: FORMAT_KEY.NONE,
    ON_NULL_FUNCTION: ERROR_TYPE.ERROR_MESSAGE
  }
};

// line chart - values
DefaultFunction[CHART_TYPE.Line]['values'] = {
  Others: {
    FUNCTION: FUNCTION.COUNT,
    FORMAT: FORMAT_KEY.NONE,
    ON_NULL_FUNCTION: ERROR_TYPE.ERROR_MESSAGE
  }
};

// line chart - values - numeric & money
DefaultFunction[CHART_TYPE.Line]['values']['Numeric'] = DefaultFunction[CHART_TYPE.Line]['values']['Money'] = {
  FUNCTION: FUNCTION.SUM,
  FORMAT: FORMAT_KEY.NONE,
  ON_NULL_FUNCTION: ERROR_TYPE.ERROR_MESSAGE
};

/** COLUMN, BAR, AREA, PIE, FUNNEL, DONUT, COMBINATION, TREEMAP, WATERFALL - same as Line **/
DefaultFunction[CHART_TYPE.Bar] = DefaultFunction[CHART_TYPE.Column] = DefaultFunction[
  CHART_TYPE.Area
] = DefaultFunction[CHART_TYPE.Pie] = DefaultFunction[CHART_TYPE.Funnel] = DefaultFunction[
  CHART_TYPE.Donut
] = DefaultFunction[CHART_TYPE.Combination] = DefaultFunction[CHART_TYPE.TreeMap] = DefaultFunction[
  CHART_TYPE.Waterfall
] = DefaultFunction[CHART_TYPE.Sparkline] = DefaultFunction[CHART_TYPE.Line];

/** BUBBLE - based on Line **/
DefaultFunction[CHART_TYPE.Bubble] = {};

// Bubble - labels, values, bubble size - same as line - values container
DefaultFunction[CHART_TYPE.Bubble]['labels'] = DefaultFunction[CHART_TYPE.Bubble]['values'] = DefaultFunction[
  CHART_TYPE.Bubble
]['bubbleSize'] = {
  Numeric: {
    FUNCTION: FUNCTION.SUM,
    FORMAT: FORMAT_KEY.NONE,
    ON_NULL_FUNCTION: ERROR_TYPE.ERROR_MESSAGE
  },
  Money: {
    FUNCTION: FUNCTION.SUM,
    FORMAT: FORMAT_KEY.NONE,
    ON_NULL_FUNCTION: ERROR_TYPE.ERROR_MESSAGE
  },
  Others: {
    FUNCTION: FUNCTION.COUNT,
    FORMAT: FORMAT_KEY.NONE,
    ON_NULL_FUNCTION: ERROR_TYPE.NOTIFY
  }
};

// Bubble - valuesLabels - same as line - labels container
DefaultFunction[CHART_TYPE.Bubble]['valuesLabels'] = {
  Datetime: {
    FUNCTION: FUNCTION.GROUP,
    FORMAT: FORMAT_KEY.YEAR,
    ON_NULL_FUNCTION: ERROR_TYPE.NOTIFY
  },
  Time: {
    FUNCTION: FUNCTION.GROUP,
    FORMAT: FORMAT_KEY.DEFAULT_TIME,
    ON_NULL_FUNCTION: ERROR_TYPE.NOTIFY
  },
  Others: {
    FUNCTION: FUNCTION.GROUP,
    FORMAT: FORMAT_KEY.NONE,
    ON_NULL_FUNCTION: ERROR_TYPE.NOTIFY
  }
};

/** SCATTER - same as bubble **/
DefaultFunction[CHART_TYPE.Scatter] = DefaultFunction[CHART_TYPE.Bubble];

/** HEATMAP - based on Line **/
DefaultFunction[CHART_TYPE.HeatMap] = {};

// Heatmap - labels, values - same as line - labels container
DefaultFunction[CHART_TYPE.HeatMap]['labels'] = DefaultFunction[CHART_TYPE.HeatMap]['values'] =
  DefaultFunction[CHART_TYPE.Line]['labels'];

// Bubble - valuesLabels - same as line - values container
DefaultFunction[CHART_TYPE.HeatMap]['valuesLabels'] = DefaultFunction[CHART_TYPE.Line]['values'];

export default DefaultFunction;



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.ChartDefaultFunction.js